import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vg2_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("vg2_token");
      localStorage.removeItem("vg2_user");
    }
    return Promise.reject(err);
  }
);

export const saveAuth = (token, user) => {
  localStorage.setItem("vg2_token", token);
  localStorage.setItem("vg2_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("vg2_token");
  localStorage.removeItem("vg2_user");
};
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("vg2_user") || "null");
  } catch {
    return null;
  }
};
